import React from "react";
import { Radio, Checkbox } from "antd";

const AskWizardMultichoice = props => {

  const { item, values, numQuestion, setValues } = props;

  let items = [];
  if (item.type === "radio") {
    item.choices.map(value => {
      items.push(<Radio style={{ display: "block", lineHeight: "22px" }} value={value}>
        {value}
      </Radio>);
      return items;
    });
    return (
      <Radio.Group
        className={"askWizard-item-radio"}
        name={"askWizard-item-field_" + numQuestion}
        value={values["askWizard-item-field_" + numQuestion]}
        onChange={e => { setValues( {...values, ["askWizard-item-field_" + numQuestion]: e.target.value} ); }}
      >
        {items}
      </Radio.Group>
    );
  } 
  item.choices.map(value => {
    items.push({ label: value, value: value });
    return items;
  });
  return (
    <Checkbox.Group
      className={"askWizard-item-checkbox"}
      value={values["askWizard-item-field_" + numQuestion]}
      options={items}
      onChange={value => { setValues( {...values, ["askWizard-item-field_" + numQuestion]: value} ); }}
    />
  );
  
};

export default AskWizardMultichoice;